import { Directive, forwardRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator, ValidatorFn } from '@angular/forms';

import { FileUploadValidators } from '../validators';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'pcs-file-upload[accepts][formControlName], pcs-file-upload[accepts][formControl]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => AcceptsDirective),
    multi: true
  }]
})
export class AcceptsDirective implements Validator, OnChanges {
  @Input() accepts: string[] = [];

  private validator: ValidatorFn;
  private onChange: () => void;

  ngOnChanges({accepts}: SimpleChanges): void {
    if (accepts) {
      this.createValidator();
      if (this.onChange) {
        this.onChange();
      }
    }
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return this.validator?.(control);
  }

  registerOnValidatorChange(fn: () => void): void {
    this.onChange = fn;
  }

  private createValidator() {
    this.validator = FileUploadValidators.allowFiles(this.accepts);
  }

}
